import { useState, useEffect } from "react";
import { FaKey } from "react-icons/fa6";
import { NasService } from "../../../../../services/NasService";
import { TextAreaDefault } from "../../../../../components/forms/TextAreaDefault";

// ============================================
// KOMPONEN: ModalWrapper (Reused)
// ============================================
const ModalWrapper = ({ isOpen, setIsOpen, title, children }) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 transition-all duration-300 ${
        isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
      }`}
      onClick={() => setIsOpen(false)}
    >
      <div
        className={`w-full max-w-md bg-[#0f172a] border border-slate-800 rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 ${
          isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header Modal */}
        <div className="px-6 py-4 border-b border-slate-800 bg-slate-900/50 flex justify-between items-center">
          <h3 className="text-lg font-bold text-gray-100">{title}</h3>
          <button
            onClick={() => setIsOpen(false)}
            className="text-slate-400 hover:text-white transition-colors"
          >
            ✕
          </button>
        </div>

        {/* Body Modal */}
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
};

// ============================================
// MAIN COMPONENT: NasUpdatePublicKey
// ============================================
export const NasUpdatePublicKeyWireguard = ({ 
    open, 
    setOpen, 
    refreshData, 
    selectedNas // Props tambahan untuk menerima data NAS yang dipilih
}) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    public_key: "",
  });

  // Efek untuk mengisi form ketika modal dibuka atau data selectedNas berubah
  useEffect(() => {
    if (open && selectedNas) {
      setFormData({
        public_key: selectedNas.public_key || "", // Ambil key lama jika ada
      });
    } else if (!open) {
      // Reset form saat modal ditutup
      setFormData({ public_key: "" });
    }
  }, [open, selectedNas]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validasi sederhana
    if (!formData.public_key.trim()) {
        alert("Public Key tidak boleh kosong");
        return;
    }

    setLoading(true);
    try {
      // Kirim data ke backend
      // Pastikan backend route update menerima ID dan field public_key
      const res = await NasService.updatePublicKey({id:selectedNas.id, data: formData});
      
      console.log(res);
      setOpen(false); // Tutup modal
      refreshData();  // Refresh tabel
    } catch (error) {
      console.log(error);
      alert("Gagal mengupdate Public Key");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWrapper
      isOpen={open}
      setIsOpen={setOpen}
      title="Update Public Key"
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        
        {/* Info Nama NAS (Read Only) */}
        <div className="bg-slate-800/50 p-3 rounded-lg border border-slate-700">
            <p className="text-xs text-slate-400 uppercase tracking-wider">Target NAS</p>
            <p className="text-sm font-bold text-white mt-1">{selectedNas?.name || 'Unknown'}</p>
        </div>

        {/* Input Public Key */}
        <div>
            <label 
                htmlFor="public_key" 
                className="block text-xs font-semibold text-slate-400 mb-2 uppercase tracking-wider"
            >
                WireGuard Public Key
            </label>
            
            {/* Menggunakan Textarea agar mudah copy paste key yang panjang */}
            <TextAreaDefault
                id="public_key"
                label="WireGuard Public Key"
                placeholder="Paste Public Key disini... (Contoh: yreGbs2X9j6x...)"
                value={formData.public_key}
                onChange={handleChange} 
                error="Public Key tidak boleh kosong"
                disabled={loading}
            />
            <p className="text-[10px] text-slate-500 mt-2">
                Key biasanya berakhiran dengan tanda sama dengan (=).
            </p>
        </div>

        {/* Tombol Aksi */}
        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 font-medium hover:bg-slate-800/50 transition-colors"
          >
            Batal
          </button>

          <button
            type="submit"
            disabled={loading}
            className="flex-1 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 disabled:bg-slate-700 disabled:text-slate-500 text-white font-semibold flex items-center justify-center gap-2 transition-all shadow-lg shadow-cyan-900/20"
          >
            {loading ? (
              <>Menyimpan...</>
            ) : (
              <>
                <FaKey />
                Update Key
              </>
            )}
          </button>
        </div>
      </form>
    </ModalWrapper>
  );
};